import {
  archiveWorkflow,
  createWorkflow,
  getWorkflow,
  listWorkflowExecutionObservations,
  listWorkflowRuns,
  listWorkflows,
  restoreWorkflow,
  saveWorkflowDefinitionGraph,
  triggerWorkflow,
  updateWorkflow,
  validateWorkflow,
} from '../../generated/api/sdk.gen.js';
import type {
  CreateWorkflowData,
  GetWorkflowData,
  ListWorkflowExecutionObservationsData,
  ListWorkflowRunsData,
  ListWorkflowsData,
  SaveWorkflowDefinitionGraphData,
  UpdateWorkflowData,
  WorkflowTriggerRequest,
} from '../../generated/api/types.gen.js';
import { type NoUrl, unwrapGenerated } from './generated.js';

export const workflowApi = {
  list: (filters?: NonNullable<ListWorkflowsData['query']>) => unwrapGenerated(listWorkflows({ query: filters })),
  getById: (id: string) => unwrapGenerated(getWorkflow({ path: { id } } satisfies NoUrl<GetWorkflowData>)),
  create: (data: NonNullable<CreateWorkflowData['body']>) => unwrapGenerated(createWorkflow({ body: data })),
  update: (id: string, data: NonNullable<UpdateWorkflowData['body']>) =>
    unwrapGenerated(updateWorkflow({ path: { id }, body: data } satisfies NoUrl<UpdateWorkflowData>)),
  archive: (id: string) => unwrapGenerated(archiveWorkflow({ path: { id } })),
  restore: (id: string) => unwrapGenerated(restoreWorkflow({ path: { id } })),
  validate: (id: string) => unwrapGenerated(validateWorkflow({ path: { id } })),
  runs: (id: string) => unwrapGenerated(listWorkflowRuns({ path: { id } } satisfies NoUrl<ListWorkflowRunsData>)),
  executionObservations: (id: string, params?: NonNullable<ListWorkflowExecutionObservationsData['query']>) =>
    unwrapGenerated(
      listWorkflowExecutionObservations({
        path: { id },
        query: params,
      } satisfies NoUrl<ListWorkflowExecutionObservationsData>),
    ),
  trigger: (id: string, context?: WorkflowTriggerRequest['context']) =>
    unwrapGenerated(triggerWorkflow({ path: { id }, body: { context } })),
  saveGraph: (id: string, body: NonNullable<SaveWorkflowDefinitionGraphData['body']>) =>
    unwrapGenerated(
      saveWorkflowDefinitionGraph({ path: { id }, body } satisfies NoUrl<SaveWorkflowDefinitionGraphData>),
    ),
};
